import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { ROUTES } from '../constants/routes';
import { userHasFn } from '../utils/rbac';

function FunctionRoute({ appKey, fnKey, children }) {
  const { user, token } = useContext(AuthContext);
  if (!user || !token) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }
  if (!userHasFn(user, appKey, fnKey)) {
    return <Navigate to={ROUTES.HOME} replace />;
  }
  return children;
}

export default FunctionRoute;
